// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
// import './plugins'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'

import Vuetify from 'vuetify'
import theme from './plugins/theme'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// import i18n from '@/i18n'
import router from '@/router'
import VueRouter from 'vue-router'
import store from '@/store'
import axios from 'axios'
import RouterPrefetch from 'vue-router-prefetch'
import BlackDashboard from './plugins/blackDashboard'
// import './registerServiceWorker'
import i18n from './i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// vue2-editor
import Vue2Editor from 'vue2-editor'
import { Quill } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
import moment_timezone from 'moment-timezone'
Vue.use(Vue2Editor)
Quill.register('modules/imageResize', ImageResize)
// moment
const moment = require('moment')
// require('moment/locale/zh-cn')
Vue.use(require('vue-moment'), {
  moment,
  moment_timezone
})

Vue.use(ElementUI)

// vue-cookie
Vue.use(require('vue-cookies'))

Vue.use(BlackDashboard)
Vue.use(VueRouter)
Vue.use(RouterPrefetch)
Vue.prototype.$http = axios
// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

if (axios.defaults.baseURL === undefined) {
  axios.defaults.baseURL = 'https://api.admin.lfstraining.com/api'
}
axios.defaults.headers.get['Accept'] = 'application/json'

// const city = JSON.parse(localStorage.getItem('city'))
// if (city) {
//   axios.defaults.headers.common['city'] = city.id
// }

// const token = localStorage.getItem('token')
const token = Vue.$cookies.get('token')

if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
Vue.prototype.customerWebDomain = 'lfstraining.com'
if (process.env.VUE_APP_CUSTOMER_WEB_DOMAIN !== undefined) {
  Vue.prototype.customerWebDomain = process.env.VUE_APP_CUSTOMER_WEB_DOMAIN
}
// Sync store with router
sync(store, router)

Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
